import React from "react";
import {Text, TextAs, TextSizes} from "@clockout-dev/design-elements";
import {CONFIDENCE_GOOD, CONFIDENCE_WARN} from "../uploads-simulator.constants";
import styles from "../styles/results.module.scss";

/**
 * Horizontal 0..1 confidence bar. Tone thresholds: >= 0.85 good (green),
 * >= 0.6 warn (amber), else bad (red). The fill width uses decile classes
 * (`meterW0` … `meterW100`) so no inline styles are needed; the exact value
 * is always shown as a percentage label next to the bar.
 *
 * @param {Object} props
 * @param {number} [props.confidence] 0..1 (missing → neutral em-dash)
 */
function ConfidenceMeter({confidence}) {
    const hasValue = typeof confidence === "number" && Number.isFinite(confidence);
    const clamped = hasValue ? Math.min(Math.max(confidence, 0), 1) : 0;
    const pct = Math.round(clamped * 100);
    const decile = Math.round(pct / 10) * 10;
    const tone = !hasValue ? "neutral" : clamped >= CONFIDENCE_GOOD ? "good" : clamped >= CONFIDENCE_WARN ? "warn" : "bad";

    return (
        <div className={styles.meter}>
            <div className={styles.meterTrack}>
                <div className={`${styles.meterFill} ${styles[`meter_${tone}`]} ${styles[`meterW${decile}`]}`} />
            </div>
            <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={`${styles.meterValue} ${styles[`meterValue_${tone}`]}`}>
                {hasValue ? `${pct}%` : "—"}
            </Text>
        </div>
    );
}

export default ConfidenceMeter;
